export const DEFAULT_INSTANCE_NAME = '__intercom__';
export const MESSAGE_EVENT_TO_LISTEN = 'message';
